import { NewsEffect } from '@siko/features/news/store/effects/news.effect';
import { UnseenNewsEffect } from '@siko/features/news/store/effects/unseen-news.effect';

export const SikoNewsEffects: any[] = [NewsEffect, UnseenNewsEffect];

export * from './news.effect';
export * from './unseen-news.effect';
